import "./App.scss";
import React from "react";
import Map from "./components/MapWrap/MapWrap";
import { MapContextProvider } from "./context/MapContext";
import { LayoutProvider } from "./context/LayoutContext";
import { GeoProvider } from "./context/GeoContext";
import CalciteThemeProvider from "calcite-react/CalciteThemeProvider";
import ReactGA from 'react-ga';
import { environment } from "./constants/environment";

function App() {
  if (window.location.hostname.includes('maps.oceanwealth.org')) {
    ReactGA.initialize(environment.googleAnalyticsKey);
    ReactGA.pageview(window.location.pathname);
  }

  return (
    <div className="appWrap">
      <CalciteThemeProvider>
        <MapContextProvider>
          <LayoutProvider>
            <GeoProvider>
              <Map />
            </GeoProvider>
          </LayoutProvider>
        </MapContextProvider>
      </CalciteThemeProvider>
    </div>
  );
}

export default App;
